var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-calendar',_vm._b({attrs:{"events":_vm.events}},'v-calendar',_vm.result,false))
}
var staticRenderFns = []

export { render, staticRenderFns }